module.exports = "<div *ngIf=\"load\">\n    <mat-spinner strokeWidth=\"2\" [diameter]=\"40\" mode=\"indeterminate\"></mat-spinner>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/loading/loading.component.html
// module id = ./src/app/components/loading/loading.component.html
// module chunks = main